import { encryptObject } from '@shared/utils';
import { getEnv } from '@shared/utils/env';
import axios from 'axios';
import request from '@services/request';

const signInService = (correspondent, user) => {
  const encryptedData = encryptObject(user);

  user.password = null;
  const apiUrl = getEnv().VITE_API_URL;
  return axios
    .post(
      `${apiUrl}/api/v2/corresponsal/login`,
      { data: encryptedData },
      {
        withCredentials: true,
        headers: {
          correspondent,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

const checkUserService = (correspondent, user) => {
  const encryptedData = encryptObject(user);
  const apiUrl = getEnv().VITE_API_URL;
  user.password = null;

  return axios
    .post(
      `${apiUrl}/api/v1/corresponsal/validate-user`,
      { data: encryptedData },
      {
        withCredentials: true,
        headers: {
          correspondent,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

const selectTenant = (user, tenantId) => {
  const apiUrl = getEnv().VITE_API_URL;
  return axios
    .post(`${apiUrl}/api/v1/corresponsal/select/correspondent/${tenantId}`, user, {
      withCredentials: true,
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

const logoutService = async (profileId) => {
  return await request.methodDelete(`/api/v1/corresponsal/logout/${profileId}`);
};

const extendSessionService = async () => {
  const apiUrl = getEnv().VITE_API_URL;
  return request
    .post(
      `${apiUrl}/api/v1/corresponsal/extendSession`,
      {},
      {
        withCredentials: true,
      }
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export { checkUserService, extendSessionService, logoutService, selectTenant, signInService };

